import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import intlTelInput from 'intl-tel-input';

@Component({
  selector: 'pod-intl-tel-input',
  templateUrl: './intl-tel-input.component.html',
  styles: [
    `
      ::ng-deep .iti {
        display: block;
      }

      ::ng-deep input {
        width: 100%;
      }
    `,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IntTelInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IntTelInputComponent),
      multi: true,
    },
  ],
})
export class IntTelInputComponent
  implements AfterViewInit, ControlValueAccessor, Validator
{
  @ViewChild('phoneInput', { static: true }) phoneInput: ElementRef;

  private iti: intlTelInput.Plugin;

  public ngClassesList: string[] = [];
  public isDisabled: boolean;

  // Placeholders for the callbacks which are later providesd
  // by the Control Value Accessor
  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  // The internal data model
  private inputValue: string = null;

  constructor(private elementRef: ElementRef) {
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  ngAfterViewInit(): void {
    if (this.phoneInput) {
      const options: intlTelInput.Options = {
        utilsScript: './assets/js/intl-tel-input/utils.js',
      };

      // trying to get the navigator country if language is the type en-US, not only en
      if (navigator.language.match(/^\w+-\w+$/)) {
        const country = navigator.language.split('-').pop();
        options.preferredCountries = [country.toLowerCase()];
      }

      this.iti = intlTelInput(this.phoneInput.nativeElement, options);

      this.phoneInput.nativeElement.addEventListener(
        'countrychange',
        this.handleInputChange
      );
    }
  }

  // Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: string): void {
    if (value !== this.inputValue) {
      this.inputValue = value;
      if (this.inputValue) {
        this.iti.setNumber(this.inputValue);
        this.onChangeCallback(this.inputValue);
      }
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  validate(control: AbstractControl): ValidationErrors {
    setTimeout(() => {
      this.setValidityClasses();
    }, 0);

    if (!this.iti || !this.iti.getNumber() || this.iti.isValidNumber()) {
      return null;
    }

    return {
      intlTel: this.iti.getValidationError().toString(),
    };
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  setValidityClasses() {
    this.ngClassesList = this.elementRef.nativeElement
      .getAttribute('class')
      .split(/\s+/)
      .filter(c => c.startsWith('ng'));
  }

  public handleInputChange() {
    let result = this.iti.getNumber().replace(/\D/g, '');
    if (result) {
      result = '+' + result;
    }
    this.onChangeCallback(result);
  }

  public handleKeyUp() {
    this.handleInputChange();
  }
}
